import { render } from "./PasswordRecovery.vue?vue&type=template&id=4f482efa&scoped=true&ts=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=ts"
export * from "./PasswordRecovery.vue?vue&type=script&lang=ts"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=4f482efa&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f482efa"]])

export default __exports__